// import { PERU } from '../../../../src/constants/dataSources';

const translateCountryNames = {
  multiservice: 'Cross Border Verification',
  // ----------- REGION (Global) -----------
  global: 'Global',

  // ----------- REGION (APAC) -----------
  india: 'India',
  indonesia: 'Indonesia',
  japan: 'Japan',
  cambodia: 'Cambodia',
  hongkong: 'Hong Kong',
  'hongkong(specialadministrativeregionofchina)': 'Hong Kong',
  singapore: 'Singapore',
  australia: 'Australia',
  china: 'China',
  newzealand: 'New Zealand',
  malaysia: 'Malaysia',
  philippines: 'Philippines',
  vietnam: 'Vietnam',

  // ----------- REGION (AFRICA) -----------
  southafrica: 'South Africa',

  // ----------- REGION (EUROPE) -----------
  austria: 'Austria',
  belgium: 'Belgium',
  denmark: 'Denmark',
  finland: 'Finland',
  france: 'France',
  germany: 'Germany',
  unitedkingdom: 'United Kingdom',
  ireland: 'Ireland',
  italy: 'Italy',
  luxembourg: 'Luxembourg',
  netherlands: 'Netherlands',
  norway: 'Norway',
  portugal: 'Portugal',
  russia: 'Russia',
  spain: 'Spain',
  slovakia: 'Slovakia',
  sweden: 'Sweden',
  switzerland: 'Switzerland',
  bulgaria: 'Bulgaria',
  greece: 'Greece',
  hungary: 'Hungary',
  poland: 'Poland',
  czechrepublic:'Czech Republic',

  // ----------- REGION (MIDDLE EAST) -----------
  bahrain: 'Bahrain',
  jordan: 'Jordan',
  kuwait: 'kuwait',
  lebanon: 'Lebanon',
  oman: 'Oman',
  saudiarabia: 'Saudi Arabia',
  turkey: 'Turkey',
  unitedarabemirates: 'United Arab Emirates',

  // ----------- REGION (THE AMERICAS) -----------
  peru: 'Peru',
  argentina: 'Argentina',
  brazil: 'Brazil',
  canada: 'Canada',
  chile: 'Chile',
  mexico: 'Mexico',
  unitedstates: 'United States Of America',

  // ----------- WATCHLIST AML -----------
  watchlistaml: 'Australia',
  watchlistAML: 'Watchlist AML',

  /* ============================================
    PAKISTAN, NEPAL, THAILAND & PAPUA NEW GUINEA
   ============================================ */
  pakistan: 'Pakistan',
  nepal: 'Nepal',
  thailand: 'Thailand',
  papuanewguinea: 'Papua New Guinea',
  kenya: 'Kenya',
  nigeria: 'Nigeria',
  bangladesh:'Bangladesh',
  morocco: 'Morocco',
};

export default translateCountryNames;
